export const NullableInputToEmptyString = (val) => (val === null ? '' : val);

export const EmptyStringToNull = (val) => (val === '' ? null : val);

export const DualObjectToStringRepresentation = (mainObj,altObj) => {
    if(mainObj === null & altObj !== null){
        return `-${altObj}`
    }
    else if(mainObj !== null & altObj === null){
        return `${mainObj}`;
    }
    else if(mainObj === null & altObj === null) {
        return '';
    }
    else{
        throw Error("Invalid case manager assigment");
    }
}

export const PrepareNullableDataForSend = (data) => {
    const transformedObj = {};
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            transformedObj[key] = EmptyStringToNull(data[key]);
        }
    }
    return transformedObj;
}


export const ReplaceNullsWithEmptyStrings = (obj) => {
    const updatedObj = {};

    for(const key in obj){
        if(obj.hasOwnProperty(key)){
            updatedObj[key] = obj[key] === null ? '' : obj[key];
        }
    }

    return updatedObj;
}

export const SortGuids = (a,b) => {
    if(a < b) return -1;
    if(a > b) return 1;
    return 0;
}

export const convertNullYesNO = (item) => {
        if(item === null) return null;

        return item === 'yes';
    }